import {
  apiClient,
  Auth,
  Pagination,
  PaginationSearchParams,
} from '@/shared/api'

import { TFavoriteRoom } from '../model/schema'

export type FavoriteRoomsSearchParams = PaginationSearchParams

export const getFavoriteRooms = async (params: FavoriteRoomsSearchParams) => {
  const { data } = await apiClient.get<Pagination<TFavoriteRoom>>({
    endpoint: `/rooms/favorites`,
    auth: Auth.REQUIRED,
    queryParams: {
      ...params,
      size: 10,
    },
  })

  return data
}
